import { onRefetch } from "../actionHandlers/onRefetch";

interface UseRefetchAttachmentReturn {
  refetchAttachment: (identifier: string) => void;
}

/**
 * Hook to handle refetching clinical attachment (fire and forget)
 * @param onRefetchInitiated - Callback to execute immediately after initiating refetch
 */
export const useRefetchAttachment = (
  onRefetchInitiated: () => void,
): UseRefetchAttachmentReturn => {
  const refetchAttachment = (identifier: string) => {
    onRefetch(identifier, onRefetchInitiated);
  };

  return {
    refetchAttachment,
  };
};
